const env = (process.env.NODE_ENV === 'prod' ? 'production' : process.env.NODE_ENV) || 'production';

const config = {
  development: {
    hostEnv: 'production',
    version: '152.0',
    debug: {
      logging: console.log,
    },
    api: {
      root: 'http://localhost:8080/v1',
      socket: 'wss://52ulccxct0.execute-api.us-east-1.amazonaws.com/prod',
      superTool: 'https://6yavl4rn64.execute-api.us-east-1.amazonaws.com/prod/supertool',
      objectOptions: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/supertool',
      dynamicVideo: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/dynamic-video/invoke',
      // TODO: GET THE ADVERTISER API KEY FROM THE DB
      testAdvertiserKey: 'M437HT4MDCGH7FF101DN3MNEC8',
    },
    fileHost: 'https://rcdn.kervinteractive.com/',
    s3Direct: 'https://s3.amazonaws.com/kerv-assets/',
    overlay: 'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-embed.js',
  },
  test: {
    hostEnv: 'production',
    version: '152.0',
    debug: {
      logging: console.log,
    },
    api: {
      root: 'http://localhost:8080/v1',
      socket: 'wss://52ulccxct0.execute-api.us-east-1.amazonaws.com/prod',
      superTool: 'https://6yavl4rn64.execute-api.us-east-1.amazonaws.com/prod/supertool',
      objectOptions: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/supertool',
      dynamicVideo: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/dynamic-video/invoke',
      // TODO: GET THE ADVERTISER API KEY FROM THE DB
      testAdvertiserKey: 'M437HT4MDCGH7FF101DN3MNEC8',
    },
    fileHost: 'https://rcdn.kervinteractive.com/',
    s3Direct: 'https://s3.amazonaws.com/kerv-assets/',
    overlay: 'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-embed.js',
  },
  production: {
    hostEnv: 'production',
    version: '152.0',
    debug: {
      logging: console.log
    },
    api: {
      root: 'https://radius.video/v1',
      socket: 'wss://52ulccxct0.execute-api.us-east-1.amazonaws.com/prod',
      superTool: 'https://6yavl4rn64.execute-api.us-east-1.amazonaws.com/prod/supertool',
      objectOptions: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/supertool',
      dynamicVideo: 'https://4m28j0xps5.execute-api.us-east-1.amazonaws.com/dynamic-video/invoke',
      // TODO: GET THE ADVERTISER API KEY FROM THE DB
      testAdvertiserKey: 'M437HT4MDCGH7FF101DN3MNEC8',
    },
    fileHost: 'https://rcdn.kervinteractive.com/',
    s3Direct: 'https://s3.amazonaws.com/kerv-assets/',
    overlay: 'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-embed.js',
    superFrame: 'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-frame.js',
    superFrameCSS: 'https://rcdn.kervinteractive.com/overlay/v3/prod/kerv-frame.css',
  },
};

console.log('Environment is ' + env);

window.console.log = config[env].debug.logging;

config[env].isDebug = () => {
  return env === 'dev'
}

export default config[env];